export enum GenericAlertTypeEnum {
    ALERT_UNKNOWN,
    ALERT_NOSIGNAL,
    ALERT_LOSS_ADHERENCE,
    ALERT_LOSS_SEPARATION,
    ALERT_GEOFENCE,
    ALERT_POTENTIAL_LOSS_SEPARATION,
    ALERT_POTENTIAL_GEOFENCE,
    ALERT_STATUS,
}